import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

const steps = [
    "Select Template",
    "Edit Mail Content",
    "Attach Files",
    "From Email",
    "Add Email IDs",
];

export default function CustomizedSteppers({ currentStep, steps: customSteps = steps }) {
    return (
        <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0, overflow: "hidden" }}>
            <Stepper
                activeStep={currentStep}
                alternativeLabel
                sx={{
                    width: "100%",
                    maxWidth: "100%",
                    "& .MuiStepLabel-label": {
                        fontSize: { xs: "0.68rem", sm: "0.8rem", md: "0.875rem" },
                        whiteSpace: "normal",
                        lineHeight: 1.2,
                    },
                }}
            >
                {customSteps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
}
